export const changeStatusBAU = state => {
    return {
        type: "STATUS_BUTTONS_UTILS",
        payload: state
    };
};